import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import events from './modules/events'
import resources from './modules/resources'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    events,
    resources
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js